import React, { useState } from 'react';
import { Modal, Text, Title, Box, Button, Group, Alert, TextInput } from '@mantine/core';
import { useAuth } from '../hooks/useAuth';
import { sadhanaService } from '../firebase/sadhanaService';

const AdminDashboard = ({ opened, onClose }) => {
  const [nextSadhanaDate, setNextSadhanaDate] = useState('');
  const [selectedLocation, setSelectedLocation] = useState('');
  const [saving, setSaving] = useState(false);
  const [message, setMessage] = useState('');
  
  const { user, signOut } = useAuth();

  const handleSave = async () => {
    if (!nextSadhanaDate || !selectedLocation) {
      setMessage('Please select both date and location');
      return;
    }

    setSaving(true);
    setMessage('');

    try {
      const result = await sadhanaService.saveSadhanaInfo({
        date: nextSadhanaDate, // Already in YYYY-MM-DD format from HTML date input
        location: selectedLocation
      });

      if (result.success) {
        setMessage('✅ Session saved successfully!');
        setNextSadhanaDate('');
        setSelectedLocation('');
      } else {
        setMessage(`❌ Error: ${result.error}`);
      }
    } catch (error) {
      setMessage(`❌ Error: ${error.message}`);
    } finally {
      setSaving(false);
    }
  };

  const handleSignOut = async () => {
    await signOut();
    onClose();
  };

  return (
    <Modal 
      opened={opened} 
      onClose={onClose} 
      title="Admin Dashboard"
      size="md"
      centered
    >
      <Box p="md">
        {user && (
          <Group justify="space-between" mb="md">
            <Text size="sm" c="dimmed">
              Signed in as: {user.email}
            </Text>
            <Button variant="subtle" color="red" onClick={handleSignOut}>
              Sign Out
            </Button>
          </Group>
        )}

        <Title order={3} mb="md">Schedule Next Sadhana</Title>

        {message && (
          <Alert mb="md" color={message.includes('✅') ? 'green' : 'red'}>
            {message}
          </Alert>
        )}

        <Box mb="md">
          <Text size="sm" fw={500} mb={5}>Next Sadhana Date</Text>
          <input
            type="date"
            value={nextSadhanaDate || ''}
            onChange={(e) => setNextSadhanaDate(e.target.value)}
            min={new Date().toISOString().split('T')[0]}
            disabled={saving}
            style={{
              width: '100%',
              padding: '8px 12px',
              border: '1px solid #ced4da',
              borderRadius: '4px',
              fontSize: '14px',
              fontFamily: 'inherit'
            }}
          />
        </Box>

        <TextInput
          label="Location"
          placeholder="Enter custom location (e.g., Centre Island, High Park, etc.)"
          value={selectedLocation}
          onChange={(e) => setSelectedLocation(e.target.value)}
          mb="md"
          disabled={saving}
        />

        <Group justify="flex-end">
          <Button
            onClick={handleSave}
            loading={saving}
            disabled={!nextSadhanaDate || !selectedLocation}
            color="#EBA75B"
          >
            Save Session
          </Button>
        </Group>
      </Box>
    </Modal>
  );
};

export default AdminDashboard;
